import axios from 'axios';
import StudyPlanFormPageActionTypes from './study-plan-form-page-action-types';
import ValidationError from '../../../utils/validation-error';

export const loadStudyPlanFormPage = ({ targetStudyPlanId, studyPlanId }) => async(dispatch, getState, { api }) => {
  dispatch({ type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_START });
  try {
    if (targetStudyPlanId > 0 || studyPlanId > 0) {
      const studyPlan = await api.get(`api/study_plans/${targetStudyPlanId ?? studyPlanId}`);
      const studyPlanCycles = await api.get(`api/study_plans/${targetStudyPlanId ?? studyPlanId}/cycles`);
      dispatch({
        type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_END,
        targetStudyPlanId,
        payload: {
          studyPlan: {
            ...studyPlan,
            id: targetStudyPlanId
              ? 0
              : studyPlan.id,
            year: targetStudyPlanId
              ? null
              : studyPlan.year,
            studyProgram: studyPlan.studyProgramId ? { id: studyPlan.studyProgramId, name: studyPlan.studyProgramName } : null,
            version: targetStudyPlanId
              ? 1
              : studyPlan.version
          },
          studyPlanCycles: studyPlanCycles?.data
        }
      });
    } else {
      dispatch({ type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_END });
    }
  } catch (error) {
    dispatch({ type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_END });
    throw error;
  }
  dispatch(loadStudyPrograms());
};

export const loadStudyPrograms = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_STUDY_PROGRAMS_START });
  try {
    const state = getState().studyPlanFormPage;
    state.studyProgramsCancelToken?.cancel();
    state.studyProgramsCancelToken = axios.CancelToken.source();
    const query = {
      skip: 0,
      limit: 50,
      keyword: payload?.keyword
    };
    const studyPrograms = await api.get(`api/study_programs`, query, state.studyProgramsCancelToken.token);
    dispatch({
      type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_STUDY_PROGRAMS_END,
      payload: {
        studyPrograms: studyPrograms ? studyPrograms.data : []
      }
    });
  } catch (error) {
    dispatch({
      type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_STUDY_PROGRAMS_END
    });
    throw error;
  }
};

export const saveStudyPlan = (payload) => async(dispatch, getState, { api, history }) => {
  dispatch({ type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_START });
  const state = getState().studyPlanFormPage;
  const apiModel = {
    ...payload,
    studyProgramId: payload.studyProgram ? payload.studyProgram.id : null
  };
  let id = payload?.id;
  try {
    let navigate;
    if (id > 0) {
      await api.put(`api/study_plans/${id}`, apiModel);
      navigate = () => history.push(`/study_plans/${id}/overview`);
    } else {
      id = payload.targetStudyPlanId ? await api.post(`api/study_plans/${payload.targetStudyPlanId}`, apiModel) : await api.post('api/study_plans', apiModel);
      navigate = () => history.replace(`/study_plans/${id}/overview`);
    }
    dispatch({
      type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_END,
      payload: {
        studyPlan: {
          ...state.studyPlan,
          id: id
        },
        studyPlanCycles: state.studyPlanCycles
      }
    });
    navigate();
  } catch (error) {
    let validationResult = null;
    if (error instanceof ValidationError) {
      validationResult = {
        errorMessage: error.message,
        errors: error.errors
      };
    }
    dispatch({
      type: StudyPlanFormPageActionTypes.LOAD_STUDY_PLAN_FORM_PAGE_END,
      payload: {
        validationResult,
        studyPlan: state.studyPlan,
        studyPlanCycles: state.studyPlanCycles
      }
    });
  }
};